import {useQuery} from "@tanstack/react-query";
import {
    SiteConfiguration,
    SiteConfigurationKey,
    SiteConfigurationsApi,
} from "@devour/client";

async function fetchSiteConfiguration(configKey: SiteConfigurationKey): Promise<SiteConfiguration> {
    if (!configKey) {
        return;
    }
    return await new SiteConfigurationsApi().getSiteConfigurations({
        configKey: configKey,
    });
}

interface GetSiteConfigurationOptions {
    staleTime?: number;
    refetchOnWindowFocus?: boolean;
}

function getSiteConfigurationQuery(configKey: SiteConfigurationKey, options?: GetSiteConfigurationOptions) {
    return {
        queryKey: [
            "get-site-configuration", configKey,
        ],
        queryFn: () => fetchSiteConfiguration(configKey),
        staleTime: options?.staleTime ?? 60000,
        refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
        enabled: Boolean(configKey),
    } as const;
}

export function useGetSiteConfiguration(configKey: SiteConfigurationKey, options?: GetSiteConfigurationOptions) {
    return useQuery(getSiteConfigurationQuery(configKey, options));
}
